export default __webpack_public_path__ + "static/media/treat-yourself-768w.0e42ff60.png";